import { memo } from "react";

import { usePerformance } from "@hooks";

import { Ellipse } from "./Ellipse";

interface BlurredEllipseProps {
  variant: "A" | "B" | "C";
  gradientId: string;
  enabled: boolean;
}

const BlurredEllipse = memo(
  ({ variant, gradientId, enabled }: BlurredEllipseProps) => {
    const { blurSupport } = usePerformance();

    return (
      <>
        {blurSupport && (
          <>
            <Ellipse
              variant={variant}
              stroke={gradientId}
              strokeWidth="8"
              opacity={enabled ? "20%" : "0%"}
              filter="url(#blur)"
            />

            <Ellipse
              variant={variant}
              stroke={gradientId}
              strokeWidth="8"
              opacity={enabled ? "40%" : "0%"}
              filter="blur(8px)"
            />
          </>
        )}
        <Ellipse
          variant={variant}
          stroke={gradientId}
          strokeWidth="4"
          opacity={enabled ? "100%" : "0%"}
        />
      </>
    );
  },
);

BlurredEllipse.displayName = "BlurredEllipse";
export { BlurredEllipse };
